
import AppLayout from './app-layout'
import Dashboard from './dashboard'
import Errors from './errors'
import Evaluations from './evaluations'
import Home from './home'
import Operations from './operations'
import Questionnaires from './questionnaires'
import Report from './report'

export default {
  AppLayout,
  Dashboard,
  Errors,
  Evaluations,
  Home,
  Operations,
  Questionnaires,
  Report
}
